import React from 'react';

export default function EditingInvoiceHistory(invoiceAuditDesc: any[]) {
    return (
        <div className="editing-invoice-history__container">
            {invoiceAuditDesc.map(audit => (
                <div className="editing-invoice-history">
                    <p>{audit.description}</p>
                    <div className="editing-invoice-history__user">
                        <img className="editing-invoice-history__avatar" alt="user" src={audit.user.imageUrl}></img>
                        <p>
                            {audit.user.givenName} {audit.user.familyName}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
}
